import {
  Alert,
  AutoComplete,
  Avatar,
  Button,
  Checkbox,
  Drawer,
  Form,
  Input,
  Radio,
  Select,
  Space,
  Spin,
  Switch,
  Tag,
} from "antd";
import axios from "axios";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import { authenticateToken } from "../../../utils/auth";
import {
  getImgUrl,
  getParamValue,
  getUpdatedUrl,
  checkStatesAndPushToHistory,
} from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useHistory, useLocation, useParams } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import _, { debounce } from "lodash";
import {
  BarcodeOutlined,
  CheckCircleFilled,
  CheckOutlined,
  CloseOutlined,
  DeleteFilled,
  EditOutlined,
  IssuesCloseOutlined,
  WarningFilled,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from "@fortawesome/free-solid-svg-icons";
import usePrevious from "../../../hooks/PreviousState";

const { Option } = Select;

const ShopOutOfStockList = (params): ReactElement => {
  const history = useHistory();
  const router = useLocation();
  const page = getParamValue(router?.search, "page");
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const shopId = shopInfo?.id;
  const merchantId = shopInfo?.merchantId;
  const [parentCategoryId, setParentCategoryId] = useState(
    getParamValue(router?.search, "parentCategoryId")
  );
  const [childCategoryId, setChildCategoryId] = useState(
    getParamValue(router?.search, "childCategoryId")
  );
  const [brandId, setBrandId] = useState<any>();

  const route = useParams();
  // --------------------------------
  const [multipleStatus, setMultipleStatus] = useState<string>();
  const [checkedList, setCheckedList] = React.useState([]);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  // --------------------------------
  const [changeStatus, setChangeStatus] = useState(undefined);
  const [childrenDrawer, setChildrenDrawer] = useState(undefined);
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(100);
  const [type, setType] = useState("JC_MART");
  const [visible, setVisible] = useState(undefined);
  const [key, setKey] = useState(getParamValue(router?.search, "key"));
  const [barCode, setBarCode] = useState(
    getParamValue(router?.search, "barCode")
  );
  const [isDeleted, setIsDeleted] = useState(false);
  const [isActive, setIsActive] = useState(
    getParamValue(router?.search, "isActive")
  );
  const [activeSearch, setActiveSearch] = useState(undefined);
  const [activeClone, setActiveClone] = useState(undefined);
  const [changeCat, setChangeCat] = useState(undefined);
  const [activeDelete, setActiveDelete] = useState(undefined);

  const [selectedProductBarcode, setSelectedProductBarcode] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState();
  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [parentCatOptions, setParentCatOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [shopProductData, setShopProductData] = useState({
    loading: false,
    data: null,
  });

  const [form] = Form.useForm();
  const fetchRef = useRef(null);

  const prevType = usePrevious(type);
  const prevShopId = usePrevious(shopId);
  const prevchildCategoryId = usePrevious(childCategoryId);
  const prevIsActive = usePrevious(isActive);
  const prevparentCategoryId = usePrevious(parentCategoryId);
  const prevBarCode = usePrevious(barCode);
  const prevKey = usePrevious(key);

  const reseAllFieldData = () => {
    setKey("");
    setBarCode("");
    setType("");
    setChildCategoryId("");
    setBrandId("");
    form.resetFields();

    history.replace(router.pathname);
    window.location.reload();
  };

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberProductsFilter")
    );
    console.log("rememberProductsFilter: ", retrievedObject);
    if (retrievedObject.barCode) setBarCode(retrievedObject.barCode);
    if (retrievedObject.parentCategoryId)
      setParentCategoryId(retrievedObject.parentCategoryId);
    if (retrievedObject.childCategoryId)
      setChildCategoryId(retrievedObject.childCategoryId);
    if (retrievedObject.key) setKey(retrievedObject.key);
    if (retrievedObject.isActive) setIsActive(retrievedObject.isActive);
    if (retrievedObject.page) {
      history.push(getUpdatedUrl("page", `${retrievedObject.page}`));
    }
  }
  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberProductsFilter",
      JSON.stringify({
        barCode: barCode,
        parentCategoryId: parentCategoryId,
        childCategoryId: childCategoryId,
        key: key,
        isActive: isActive,
        page: page,
      })
    );
  };

  // **********************************
  // Search Options
  // **********************************
  const getParentCatOptions = useCallback(
    async (val?: string) => {
      setParentCatOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/categories/admin?id=${shopInfo?.hubId}&page=0&limit=20` +
          (val ? `&name=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setParentCatOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            value: category?.category?.id,
            label: category?.category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      setCategoriesOptions({ loading: true, list: [] });
      if (shopInfo?.hubId) {
        if (parentCategoryId) {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-parent?categoryId=${parentCategoryId}` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        } else {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-hub?hubId=${shopInfo?.hubId}&page=0&limit=20` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        }
      } else {
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/categories?shopId=${shopId}&page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.category?.id,
              label: category?.category?.title,
            };
          }),
        });
      }
    },
    [type, parentCategoryId]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/by-merchant?page=0&limit=30` +
          (merchantId ? `&merchantId=${merchantId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            value: shop?.id,
            label: shop?.name,
          };
        }),
      });
    },
    [type, merchantId]
  );

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/stock-out-products?page=0&limit=20&deleted=${isDeleted}` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (shopId ? `&shopId=${shopId}` : ``) +
          (key ? `&name=${key}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.products?.map(
          (product: { name: any; barCode: any }) => {
            return {
              value: product?.barCode,
              label: product?.name,
            };
          }
        ),
      });
    },
    [status, type, key, isDeleted, isActive]
  );

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      setProductOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/stock-out-products?page=0&limit=20&deleted=${isDeleted}` +
          (shopId ? `&shopId=${shopId}` : ``) +
          (val ? `&name=${val}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductOptions({
        loading: false,
        list: res?.data?.products?.map((product: { name: any }) => {
          return {
            value: product?.name,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, barCode, isDeleted, isActive]
  );
  // **********************************
  // Search Options
  // **********************************

  const getShopProduct = useCallback(
    (getShopId) => {
      if (getShopId) {
        try {
          let shouldResetPage = false;
          if (localStorage.getItem("rememberProductsFilter") != null) {
            checkLocalStorageAndSetParams();
            localStorage.removeItem("rememberProductsFilter");
          } else {
            shouldResetPage = checkStatesAndPushToHistory(
              [
                prevparentCategoryId,
                prevchildCategoryId,
                prevBarCode,
                prevKey,
                prevIsActive,
              ],
              [parentCategoryId, childCategoryId, barCode, key, isActive],
              [
                "parentCategoryId",
                "childCategoryId",
                "barCode",
                "key",
                "isActive",
              ],
              history
            );
          }
          setShopProductData({ loading: true, data: undefined });
          axios
            .get(
              `${process.env.REACT_APP_CATALOG_READER_API}/admin/product/stock-out-products?shopId=${getShopId}` +
                `&page=${shouldResetPage ? 0 : page || 0}` +
                `&limit=${limit || 16}` +
                `&deleted=${isDeleted}` +
                (status ? `&status=${status}` : ``) +
                (key ? `&name=${key}` : ``) +
                (barCode ? `&barCode=${barCode}` : ``) +
                (childCategoryId
                  ? `&categoryId=${childCategoryId}`
                  : parentCategoryId
                  ? `&categoryId=${parentCategoryId}`
                  : ``) +
                (brandId ? `&brandId=${brandId}` : ``) +
                (type ? `&type=${type}` : ``) +
                (isActive ? `&isActive=${isActive}` : ``),
              {
                headers: {
                  Authorization: `Bearer ${authenticateToken()}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setShopProductData({
                  loading: false,
                  data: data?.data,
                });
                setCheckedList(
                  data.data.products.map((product) => product?.barCode)
                );
              } else {
                setShopProductData({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setShopProductData({ loading: false, data: null });

              console.log(err);
            });
        } catch (error) {
          setShopProductData({ loading: false, data: null });

          console.log(error, "error");
        }
      }
    },
    [
      limit,
      page,
      status,
      childCategoryId,
      brandId,
      key,
      barCode,
      type,
      isDeleted,
      isActive,
    ]
  );

  const onDelete = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/product`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
          // deleted: !val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getShopProduct(shopId);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const onMultipleStatusChange = async () => {
    if (changeStatus === "DELETEANDACTIVE") {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/multiple-inactive-but-active-in-other-shops`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            barCodes: selectedProductBarcode,
            shopId: shopId,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Selected Item(s) Status Updated Successfully",
              "success"
            );
            getShopProduct(shopId);
            setVisible(undefined);
            setChildrenDrawer(undefined);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/multiple-active-inactive`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            barCodes: selectedProductBarcode,
            shopIds: selectedShopId || [shopId],
            isActive: changeStatus === "ACTIVE" ? true : false,
            deleted: changeStatus === "DELETE" ? true : false,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Selected Item(s) Status Updated Successfully",
              "success"
            );
            getShopProduct(shopId);
            setVisible(undefined);
            setChildrenDrawer(undefined);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  const onChange = (e) => {
    setSelectedProductBarcode((prevVal: any) => {
      const newVal = e;
      let newArr = Array.from(prevVal);
      const found = prevVal.find((item) => item === newVal);
      if (!found) {
        newArr.push(newVal);
      } else {
        newArr = newArr.filter((item) => item !== newVal);
      }
      return newArr;
    });

    setIndeterminate(
      !!checkedList.length &&
        checkedList.length <= selectedProductBarcode.length
    );
    setCheckAll(checkedList.length === selectedProductBarcode.length);
  };

  const onCheckAllChange = (e) => {
    setSelectedProductBarcode(e.target.checked ? checkedList : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "product") getProductOptions(value);
        else if (field === "productByBarcode")
          getProductByBarcodeOptions(value);
        else if (field === "parentCategory") getParentCatOptions(value);
        else if (field === "category") getCategoriesOptions(value);
        else if (field === "brand") getBrandsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getParentCatOptions,
    getCategoriesOptions,
    getBrandsOptions,
    getProductOptions,
    getProductByBarcodeOptions,
  ]);

  useEffect(() => {
    if (multipleStatus) {
      onMultipleStatusChange();
    }
  }, [multipleStatus]);

  useEffect(() => {
    getShopProduct(shopId);
  }, [getShopProduct, shopId]);

  useEffect(() => {
    if (activeSearch || changeCat) {
      getParentCatOptions();
      getCategoriesOptions();
      getBrandsOptions();
    }
  }, [
    getBrandsOptions,
    getParentCatOptions,
    getCategoriesOptions,
    activeSearch,
    changeCat,
  ]);

  useEffect(() => {
    if (parentCategoryId) {
      setChildCategoryId(undefined);
      form.resetFields(["sub_category_search"]);
    }
  }, [setChildCategoryId, parentCategoryId]);

  useEffect(() => {
    if (activeDelete) {
      form.resetFields();
    }
  }, [activeDelete]);

  useEffect(() => {
    if (activeClone) {
      form.resetFields();
    }
  }, [activeClone]);

  useEffect(() => {
    getShopsOptions();
  }, [getShopsOptions]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
    setActiveClone(undefined);
    setChangeCat(undefined);
    setActiveDelete(undefined);
  };

  const onChildrenDrawerClose = () => {
    setChildrenDrawer(undefined);
    setChangeStatus(undefined);
  };

  return (
    <React.Fragment>
      <ShopLayout shopId={shopId}>
        <>
          <section className="product-lists">
            <div className="product-list-item-area white-bg">
              <ShopHeader
                leftarea={"Out of Stock List"}
                rightarea={
                  <div className="d-flex">
                    {activeSearch ? (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(false);
                          reseAllFieldData();
                        }}
                        danger
                      >
                        <ZoomOutOutlined />
                      </Button>
                    ) : (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(true);
                        }}
                      >
                        <ZoomInOutlined />
                      </Button>
                    )}
                    <Button
                      type="primary"
                      danger
                      onClick={() => {
                        showDrawer();
                        setActiveDelete(true);
                      }}
                      disabled={!selectedProductBarcode.length}
                      className="ml-2"
                      title="Change Staus"
                    >
                      <FontAwesomeIcon icon={faToggleOn} />
                    </Button>
                  </div>
                }
              />

              {activeSearch && (
                <div className="search_area mb-0">
                  <Form form={form} className="search_form">
                    <Form.Item name="barcode_search" initialValue={barCode}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "productByBarcode")}
                        onSelect={(val) => setBarCode(val)}
                        options={productBarcodeOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productBarcodeOptions?.loading ? (
                            <Spin size="small" />
                          ) : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by BarCode"
                          onSearch={(val) => {
                            setBarCode(val);
                          }}
                          enterButton
                          loading={productBarcodeOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>

                    <Form.Item name="product_search" initialValue={key}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "product")}
                        onSelect={(val) => setKey(val.toString())}
                        options={productOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productOptions?.loading ? <Spin size="small" /> : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by Name"
                          onSearch={(val) => {
                            setKey(val);
                          }}
                          enterButton
                          loading={productOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>

                    <Form.Item
                      name="parentCategory_search"
                      initialValue={parentCategoryId}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Filter by Category"
                        optionFilterProp="children"
                        onChange={(val) => setParentCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "parentCategory")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {parentCatOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="sub_category_search"
                      initialValue={childCategoryId}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Sub Category"
                        optionFilterProp="children"
                        onChange={(val) => setChildCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "category")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {categoriesOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    {/* <Form.Item name="brand_search">
                      <Select
                        showSearch
                        placeholder="Filter by Brand"
                        optionFilterProp="children"
                        onChange={(val) => setBrandId(val)}
                        onSearch={(e) => handleSearch(e, "brand")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {brandsOptions.list.length ? (
                          <Option value={""}>All Brands</Option>
                        ) : undefined}{" "}
                        {brandsOptions.list.map((brand) => (
                          <Option value={brand.id}>{brand.name}</Option>
                        ))}
                      </Select>
                    </Form.Item> */}

                    <Form.Item
                      name="deleted_search"
                      initialValue={
                        isActive == "true"
                          ? "ACTIVE"
                          : isActive == "false"
                          ? "INACTIVE"
                          : "ALL"
                      }
                    >
                      <Select
                        showSearch
                        placeholder="Status"
                        onChange={(val) => setIsActive(val as string)}
                      >
                        <Select.Option value="">ALL</Select.Option>
                        <Select.Option value={"true"}>ACTIVE</Select.Option>
                        <Select.Option value={"false"}>INACTIVE</Select.Option>
                      </Select>
                    </Form.Item>
                  </Form>
                  <div className="search_btn">
                    <Button
                      type="primary"
                      size="large"
                      danger
                      onClick={reseAllFieldData}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              )}

              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading major">
                      <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={
                          checkAll ||
                          selectedProductBarcode?.length === checkedList?.length
                        }
                        className="mr-3"
                      >
                        Check all
                      </Checkbox>
                    </div>
                    <div className="single-product-heading major">
                      <span>Stock & Price</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Status</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Action</span>
                    </div>
                  </div>
                </div>
              </div>

              {shopProductData.loading ? (
                <Loading />
              ) : (
                <div className="product-table">
                  <div className="product-table-area">
                    {shopProductData?.data?.products?.length ? (
                      shopProductData?.data?.products?.map(
                        (product: any, index: number) => (
                          <React.Fragment key={index}>
                            <Link
                              to={`/shops/${
                                (route as any)?.shopId as string
                              }/products/${product?.slug}/details`}
                              onClick={saveCurrentStatesInLocalStorage}
                            >
                              <div className="single-product-wrapper">
                                <div className="single-product major">
                                  <Checkbox
                                    onClick={(e) => {
                                      e.preventDefault();
                                      onChange(product?.barCode);
                                    }}
                                    checked={selectedProductBarcode?.find(
                                      (item) => product?.barCode === item
                                    )}
                                    className="mr-3"
                                    value={product?.barCode}
                                  />
                                  <Avatar
                                    shape="square"
                                    size={50}
                                    src={getImgUrl(product?.productImage)}
                                    className="mr-3"
                                  />
                                  <span className="name">{product?.name}</span>
                                </div>

                                <div className="single-product major">
                                  <div className="">
                                    {product?.variations?.length
                                      ? product?.variations?.map(
                                          (variant, index) => (
                                            <React.Fragment key={index}>
                                              <div className="d-flex justify-content-start mb-1">
                                                {variant?.barCode ? (
                                                  <Tag className="d-flex align-items-center">
                                                    <BarcodeOutlined className="mr-1" />{" "}
                                                    {variant?.barCode}
                                                  </Tag>
                                                ) : product?.barCode ? (
                                                  <Tag className="d-flex align-items-center">
                                                    <BarcodeOutlined className="mr-1" />{" "}
                                                    {product?.barCode}
                                                  </Tag>
                                                ) : undefined}
                                                <Tag
                                                  color={
                                                    variant?.stock < 10
                                                      ? `red`
                                                      : `green`
                                                  }
                                                >
                                                  {variant?.variationName?.toUpperCase()}
                                                  : <b>{variant?.stock || 0}</b>
                                                </Tag>
                                              </div>
                                              <div className="d-flex justify-content-start mb-1">
                                                <Tag>
                                                  MRP{" "}
                                                  {variant?.price?.currencyCode}
                                                  {variant?.price
                                                    ?.discountedPrice ||
                                                    variant?.price?.mrp}
                                                  {variant?.price
                                                    ?.discountedPrice &&
                                                    variant?.price
                                                      ?.discountedPrice !==
                                                      variant?.price?.mrp && (
                                                      <span className="text-danger">
                                                        {" "}
                                                        <del>
                                                          {variant?.price
                                                            ?.currencyCode ||
                                                            "Tk"}
                                                          {variant?.price?.mrp}
                                                        </del>
                                                      </span>
                                                    )}
                                                </Tag>
                                                <Tag>
                                                  TP {variant?.price?.tp}{" "}
                                                  {variant?.price?.currencyCode}
                                                </Tag>
                                              </div>
                                            </React.Fragment>
                                          )
                                        )
                                      : undefined}
                                  </div>
                                </div>

                                {/* <div className="single-product">
                                <span className="name d-flex-l">
                                  {product?.numberOfRating ? (
                                    <Rate
                                      value={product?.rating || 0}
                                      disabled
                                    />
                                  ) : (
                                    <Rate value={0} disabled />
                                  )}
                                  {product?.numberOfRating ? (
                                    <small className="ml-1">
                                      ({product?.numberOfRating})
                                    </small>
                                  ) : undefined}
                                </span>
                              </div> */}
                                <div className="single-product">
                                  <Switch
                                    checkedChildren={<CheckOutlined />}
                                    unCheckedChildren={<CloseOutlined />}
                                    defaultChecked={product?.isActive}
                                    onChange={(val, e) => {
                                      e.preventDefault();
                                      onDelete(product?.id, val);
                                    }}
                                  />
                                </div>

                                <div className="single-product">
                                  <Button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      saveCurrentStatesInLocalStorage();
                                      history.push(
                                        `/shops/${
                                          (route as any)?.shopId as string
                                        }/products/${product?.slug}/edit`
                                      );
                                    }}
                                  >
                                    <EditOutlined />
                                  </Button>
                                </div>
                              </div>
                            </Link>
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Empty data="Products" />
                    )}
                  </div>
                </div>
              )}
              <PaginationTwo
                {...shopProductData?.data}
                limit={limit}
                page={shopProductData?.data?.currentPageNumber || 0}
              />
            </div>
          </section>
        </>
      </ShopLayout>
      <Drawer
        title="Change Status"
        placement="right"
        onClose={onClose}
        visible={visible}
        width={400}
      >
        <div className="">
          <Form
            name="control-hooks"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            className="ant-form ant-form-vertical"
            onFinish={onMultipleStatusChange}
            form={form} // like ref
            layout="vertical"
            autoComplete="off"
            initialValues={{
              shopId: !activeDelete ? [shopId] : undefined,
            }}
          >
            <Form.Item label="Product Barcodes">
              <Input.TextArea
                value={selectedProductBarcode}
                disabled
                rows={8}
              />
            </Form.Item>
            {activeDelete && (
              <Alert
                message="Are you sure to make change status of selected Items"
                type="warning"
                closable
                onClose={onClose}
                className="mb-4"
              />
            )}

            <Button
              type="primary"
              size="large"
              onClick={() => setChildrenDrawer(true)}
            >
              <FontAwesomeIcon icon={faToggleOn} className="mr-2" />
              Change Status
            </Button>
          </Form>
        </div>

        <Drawer
          title="Choose Option"
          width={365}
          closable={false}
          onClose={onChildrenDrawerClose}
          visible={childrenDrawer}
        >
          <Radio.Group>
            <Space direction="vertical">
              <Radio value="1" onChange={() => setChangeStatus("ACTIVE")}>
                <CheckCircleFilled className="text-success" /> ACTIVE SELECTED
                ITEMS
              </Radio>
              <Radio value="2" onChange={() => setChangeStatus("NACTIVE")}>
                <WarningFilled className="text-warning" /> INACTIVE SELECTED
                ITEMS
              </Radio>
              <Radio
                value="3"
                onChange={() => setChangeStatus("DELETEANDACTIVE")}
              >
                <IssuesCloseOutlined className="text-danger mr-1" />
                INACTIVE &amp; ACTIVE IN ANOTHER SHOP
              </Radio>
              <Radio value="4" onChange={() => setChangeStatus("DELETE")}>
                <DeleteFilled className="text-danger" /> DELETE SELECTED ITEMS
              </Radio>
            </Space>
          </Radio.Group>
          <Button
            type="primary"
            danger
            title="Clone Selected Items"
            disabled={!checkedList || !changeStatus}
            htmlType="submit"
            size="large"
            className="mt-4"
            onClick={() => onMultipleStatusChange()}
          >
            Change Status
          </Button>
        </Drawer>
      </Drawer>
    </React.Fragment>
  );
};

export default ShopOutOfStockList;
